function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';

import { ModuleBody, ModuleDescription } from '../';

import Turndown from "turndown";

var turndown = new Turndown({
    headingStyle: "atx",
    bulletListMarker: "-"
});

//turndown.remove('img')


var InboxMessageBody = function (_Component) {
    _inherits(InboxMessageBody, _Component);

    function InboxMessageBody() {
        var _temp, _this, _ret;

        _classCallCheck(this, InboxMessageBody);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getMessage = function () {
            var message = _this.props.message;


            var html = document.createElement("div");
            html.innerHTML = message;

            var text = html.textContent || html.innerText || message;

            var markdown = message;

            if (message) {
                markdown = turndown.turndown(message);
            }

            return {
                text: text,
                markdown: markdown
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    InboxMessageBody.prototype.render = function render() {
        var _props = this.props,
            message = _props.message,
            expanded = _props.expanded;


        if (this.props.children) {

            return React.createElement(
                ModuleBody,
                null,
                this.props.children
            );
        }

        var _getMessage = this.getMessage(),
            markdown = _getMessage.markdown,
            text = _getMessage.text;

        if (expanded) {

            return React.createElement(
                ModuleBody,
                null,
                React.createElement(ReactMarkdown, { source: markdown })
            );
        }

        return React.createElement(
            ModuleBody,
            null,
            React.createElement(ModuleDescription, { description: text })
        );
    };

    return InboxMessageBody;
}(Component);

export default InboxMessageBody;